<template>
  <section>
    <span>
      <div style="text-align: right">
        <el-tooltip
          class="item"
          effect="dark"
          content="Download do DANFE"
          placement="bottom"
        >
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-download"
            @click.native="downloadPDF"
          >Download</el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="Fechar preview do DANFE"
          placement="bottom"
        >
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-close"
            @click="closeDialog"
          >Fechar</el-button>
        </el-tooltip>
      </div>
      <br>
      <pdf
        ref="pdf"
        style="border: 10px solid #4b5760"
        v-for="i in numPages"
        :key="i"
        :src="src"
        :page="i"
      ></pdf>
    </span>
  </section>
</template>

<script>
import pdf from "vue-pdf"

export default {
  name: "pdf-viewer",
  props: ["pdfFile", "nfeChave"],
  components: {
    pdf
  },
  data () {
    return {
      src: pdf.createLoadingTask(this.pdfFile),
      numPages: undefined
    };
  },
  methods: {
    closeDialog () {
      this.$emit('hideDialog')
    },
    downloadPDF () {
      const linkSource = this.pdfFile
      const downloadLink = document.createElement("a")
      const fileName = "nfe" + this.nfeChave + ".pdf"

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  },
  mounted () {
    this.src.promise.then(pdf => {
      this.numPages = pdf.numPages
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pdf-viewer/pdf-viewer.vue